export const SHOW_MESSAGE_SUCCESS = "SHOW_MESSAGE_SUCCESS"
export const SHOW_MESSAGE_ERROR = "SHOW_MESSAGE_ERROR"
export const RESET_STATE = "RESET_STATE"